/**
 * DATA REQUESTS, as the person sees them (wave 116).
 *
 * An erasure or an export is honoured only for somebody who proved they asked:
 * the request came from the address on the account, or the signed-in person
 * confirms it from the console. This is the console half — a notice with one
 * button — and the export it later hands them. The backoffice writes both; the
 * api serves them; the SPA draws them.
 */
import { z } from "zod";

/** How long a confirmation, an attestation and a finished export each stay good. */
export const DSAR_CHECK_DAYS = 7;
export const DSAR_EXPORT_DAYS = 7;

export const DsarKind = z.enum(["erasure", "export"]);
export type DsarKind = z.infer<typeof DsarKind>;

/**
 * What the console shows, and nothing the operator typed: a request to confirm
 * (kind and its expiry) and an export ready to download (and its expiry).
 * The sentences are the SPA's; this is the data.
 */
export type DataRequestList = {
  confirmations: { id: string; kind: DsarKind; requested_at: string; expires_at: string }[];
  exports: { id: string; created_at: string; expires_at: string; downloaded_at: string | null }[];
};
